import { Component, Input, ViewContainerRef, TemplateRef, Injectable, ViewChild, AfterViewInit, ElementRef, EventEmitter } from '@angular/core';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { Router, NavigationStart } from "@angular/router";
import { CookieService } from 'ngx-cookie-service';
import { AppService } from './services/app/app.service'; 

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})


export class AppComponent {

  title = 'app';
  isLoggedIn: boolean = false;
  // private connectionIsEstablished = false;  
  //private _stockHubConnection: HubConnection;  
  //connectionEstablished = new EventEmitter<Boolean>(); 
  constructor(public toastr: ToastsManager,
    private readonly router: Router,
    vcr: ViewContainerRef,
    private cookieService: CookieService,
    private appService: AppService) {
    this.toastr.setRootViewContainerRef(vcr);
    this.router.events
      .subscribe((event) => {
        if (event instanceof NavigationStart) {
          let currentUrlSlug = event.url.slice(1);
          currentUrlSlug = currentUrlSlug.split("/")[0];
          if (currentUrlSlug == "forgot-password" || currentUrlSlug == "reset-password") {

          }
          else {
            this.CheckLogin();
          }
        }
      });


    //this.createConnection(); 
    //this.startConnection();  
  }

  //private createConnection() {
  //  this._stockHubConnection = new HubConnectionBuilder()
  //    .withUrl('/notify')
  //    .build();
  //}

  //private startConnection(): void {
  //  this._stockHubConnection
  //    .start()
  //    .then(() => {
  //      this.connectionIsEstablished = true;
  
  //      this.connectionEstablished.emit(true);
  //    }).catch(err => {
  //      setTimeout(this.startConnection(), 5000);
  //    });
  //}


  fun() {
    this.router.events
      .subscribe((event) => {
        if (event instanceof NavigationStart) {
          let currentUrlSlug = event.url.slice(1);
          currentUrlSlug = currentUrlSlug.split("/")[0];
          if (currentUrlSlug == "forgot-password" || currentUrlSlug == "reset-password") {
          }
          else {
            this.CheckLogin();
          }
        }
      });
  }

  CheckLogin() {
    this.appService.CheckLogin(this.cookieService.get('Login')).subscribe(
      data => {
        this.isLoggedIn = data
        if (!data) {
          this.router.navigate(["/login"]);
        }
      });
    //this.isLoggedIn = true;
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts